import { jsx as _jsx } from "react/jsx-runtime";
import { useLoginWithGoogleRequest } from '../hooks/useLoginWithGoogleRequest.ts';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
// @ts-ignore
const LoginWithGoogleButton = ({ is_signup }) => {
    const loginWithGoogleRequest = useLoginWithGoogleRequest();
    return (_jsx(GoogleOAuthProvider, { clientId: "8698130451-mf0dj20mhhpq0cu4f8g4k5v0770lqnuh.apps.googleusercontent.com", children: _jsx(GoogleLogin, { theme: 'filled_blue', size: 'medium', text: is_signup ? 'signup_with' : 'signin_with', width: '300', onSuccess: (credentialResponse) => {
                loginWithGoogleRequest(credentialResponse.credential)
                    .then(() => {
                    window.location.replace('/');
                })
                    .catch((e) => {
                    alert((e && e.message) || e);
                });
            } }) }));
};
export default LoginWithGoogleButton;
